export const getUpperYarraValleyData = () => ({
  name: "Upper Yarra Valley",
  country: "Australie",
  region: "Yarra Valley",
  description: "Upper Yarra Valley est une sous-région d'altitude de la Yarra Valley, réputée pour ses Pinot Noir élégants et ses Chardonnay complexes. Son climat frais et ses vignobles en altitude créent des conditions idéales pour des vins de grande finesse.",
  type: "subregion",
  mapAreas: [
    { region: "Upper Yarra Valley", x: 60, y: 70, color: "#c486c4", size: 3 }
  ],
  statistics: {
    totalArea: "2,000 ha",
    production: "0.12 million hectolitres",
    altitude: "200-400m",
    appellations: "Upper Yarra Valley GI",
    exportPercentage: "30%"
  },
  characteristics: {
    climate: "Climat frais avec altitude élevée, étés chauds, hivers froids, précipitations régulières",
    soil: "Sols volcaniques, argileux, excellente drainage",
    viticulture: "Viticulture moderne, vignobles en altitude, rendements limités"
  },
  wineStyles: {
    red: "Pinot Noir élégants et complexes, Shiraz frais, assemblages délicats",
    white: "Chardonnay frais et aromatiques, Sauvignon Blanc tendus, Riesling complexes",
    rose: "Rosés frais et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle, spécialité régionale"
  },
  history: "Upper Yarra Valley s'est développée comme sous-région distincte dans les années 1980. La sous-région s'est rapidement imposée pour ses vins de climat frais de qualité exceptionnelle.",
  foodPairing: "Cuisine australienne : fruits de mer, poissons, viandes blanches, fromages affinés, cuisine fusion.",
  grapeVarieties: {
    white: ["Chardonnay", "Sauvignon Blanc", "Sémillon"],
    red: ["Pinot Noir", "Shiraz", "Cabernet Sauvignon"]
  },
  keyProducers: ["Yeringberg", "Yarra Yering", "Mount Mary"],
  notableWines: {
    "pinot-noir": "Pinot Noir élégants et complexes",
    "chardonnay": "Chardonnay frais et aromatiques",
    "shiraz": "Shiraz frais et élégants"
  }
}); 